function setCollapsibleHeight(container) {
  if (container) {
    var height = container.querySelector('.collapsible-content__inner').offsetHeight;
    container.style.height = height + 'px';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var truncateElements = document.querySelectorAll('.truncate-text');
  
  truncateElements.forEach(function(element) {
    var fullHtml = element.innerHTML;
    // Create a temporary div to count text length without affecting display
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHtml;
    var textContent = tempDiv.textContent;
    var contentLength = textContent.trim().length;
    
    var maxLength = parseInt(element.getAttribute('data-truncate-length'));
    
    if (contentLength > maxLength) {
      // Create a temporary element to handle HTML content
      var temp = document.createElement('div');
      temp.innerHTML = fullHtml;
      
      // Get all text nodes and their positions
      var textNodes = [];
      var charCount = 0;
      var truncatedHtml = '';
      
      function getTextNodes(node) {
        if (node.nodeType === 3) { // Text node
          textNodes.push({
            node: node,
            start: charCount,
            text: node.textContent
          });
          charCount += node.textContent.length;
        } else if (node.nodeType === 1) { // Element node
          Array.from(node.childNodes).forEach(getTextNodes);
        }
      }
      
      getTextNodes(temp);
      
      // Find the position to truncate
      var currentLength = 0;
      var truncateIndex = -1;
      var truncateNode = null;
      
      for (var i = 0; i < textNodes.length; i++) {
        var nodeLength = textNodes[i].text.length;
        if (currentLength + nodeLength > maxLength) {
          truncateNode = textNodes[i];
          truncateIndex = maxLength - currentLength;
          break;
        }
        currentLength += nodeLength;
      }
      
      if (truncateNode) {
        // Truncate the specific text node
        truncateNode.node.textContent = truncateNode.node.textContent.substring(0, truncateIndex) + '...';
        
        // Remove all nodes after the truncated node
        var found = false;
        function removeAfterTruncate(node) {
          Array.from(node.childNodes).forEach(function(child) {
            if (child === truncateNode.node) {
              found = true;
            } else if (found && child.nextSibling) {
              node.removeChild(child.nextSibling);
            }
            if (child.nodeType === 1) {
              removeAfterTruncate(child);
            }
          });
        }
        removeAfterTruncate(temp);
        
        // Set the truncated content
        element.innerHTML = temp.innerHTML;
        
        // Create and add the Read More button
        var readMoreBtn = document.createElement('button');
        readMoreBtn.setAttribute('type', 'button');
        readMoreBtn.classList.add('btn', 'btn--tertiary', 'read-more-btn');
        readMoreBtn.textContent = 'Read more';
        element.insertAdjacentElement('afterend', readMoreBtn);
        
        readMoreBtn.addEventListener('click', function() {
          var collapsibleContainer = element.closest('.collapsible-content');
          if (readMoreBtn.textContent === 'Read more') {
            element.innerHTML = fullHtml;
            readMoreBtn.textContent = 'Read less';
          } else {
            element.innerHTML = temp.innerHTML;
            readMoreBtn.textContent = 'Read more';
          }
          
          // Adjust the height of the collapsible content box
          if (collapsibleContainer) {
            setCollapsibleHeight(collapsibleContainer);
          }
        });
      }
    }
  });

  function toggleAtcButton() {
    const bisBtn = document.querySelector('#SI_trigger');
    const atcBtn = document.querySelector('.product-single__form button.add-to-cart');
    const productActs = document.querySelector('.product_acts');

    if (bisBtn && atcBtn && productActs) {
      const message = productActs.querySelector('.product-block');

      if(atcBtn.disabled) {
        atcBtn.style.display = 'none';
        message.style.display = 'block';
      } else {
        atcBtn.style.display = 'block';
        message.style.display = 'none';
      }
    }
  }

  setTimeout(() => {
    toggleAtcButton();
  }, 1200);
  setTimeout(() => {
    const variantToggleArea = document.querySelector('variant-swatch-king');
    if (variantToggleArea) {
      variantToggleArea.addEventListener('click', () => {
        toggleAtcButton();
      })
    }
  }, 1200);

});

